import React, { useState } from 'react';
import styles from './CalendarHeader.module.scss';
import { setMonth, setYear } from 'date-fns';
import Text from '../../../atoms/text/Text';
const right = '/icons/calendar/right.svg';
const left = '/icons/calendar/left.svg';

import { format } from 'date-fns';
import { ar } from 'date-fns/locale';
const months = [
  'Filter.January',
  'Filter.February',
  'Filter.March',
  'Filter.April',
  'Filter.May',
  'Filter.June',
  'Filter.July',
  'Filter.August',
  'Filter.September',
  'Filter.October',
  'Filter.November',
  'Filter.December',
];

const years = [2023, 2024];

const CalendarHeader = ({
  currentMonth,
  setCurrentMonth,
  eventsForCurrentMonth,
}) => {
  const [showMonthDropdown, setShowMonthDropdown] = useState(false);
  const [showYearDropdown, setShowYearDropdown] = useState(false);

  const handleMonthClick = (month) => {
    setCurrentMonth(setMonth(currentMonth, months.indexOf(month)));
    setShowMonthDropdown(false);
  };

  const handleYearClick = (year) => {
    setCurrentMonth(setYear(currentMonth, year));
    setShowYearDropdown(false);
  };

  const toggleMonthDropdown = () => {
    setShowMonthDropdown(!showMonthDropdown);
    setShowYearDropdown(false);
  };

  const toggleYearDropdown = () => {
    setShowYearDropdown(!showYearDropdown);
    setShowMonthDropdown(false);
  };

  const nextMonth = () => {
    if (currentMonth.getFullYear() === 2024 && currentMonth.getMonth() === 11) {
      return;
    }
    setCurrentMonth(setMonth(currentMonth, currentMonth.getMonth() + 1));
  };

  const previousMonth = () => {
    if (currentMonth.getFullYear() === 2023 && currentMonth.getMonth() === 0) {
      return;
    }
    setCurrentMonth(setMonth(currentMonth, currentMonth.getMonth() - 1));
  };

  const formattedMonth = format(currentMonth, 'MMMM', { locale: ar });
  const formattedYear = format(currentMonth, 'yyyy');
  return (
    <div className={styles.header} key={currentMonth}>
      <Text
        title=""
        variant="text-bold-italic-20"
        className={styles.text}
        onClick={previousMonth}
        svg={left}
      />
      <div className={styles['select-container']}>
        <div className={styles.select}>
          <Text
            title={formattedMonth}
            variant="text-bold-italic-20"
            className={styles.text}
            onClick={toggleMonthDropdown}
          />
        </div>
        {showMonthDropdown && (
          <div className={styles.options}>
            {months.map((month, index) => (
              <div
                className={styles.item}
                key={index}
                onClick={() => handleMonthClick(month)}
              >
                <Text
                  title={month}
                  variant="text-bold-italic-16-black"
                  style={{ cursor: 'pointer' }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
      <Text title=" - " variant="text-bold-italic-20" />
      <div className={styles['select-container']}>
        <div className={styles.select}>
          <Text
            title={formattedYear}
            variant="text-bold-italic-20"
            className={styles.text}
            onClick={toggleYearDropdown}
          />
        </div>
        {showYearDropdown && (
          <div className={styles.options}>
            {years.map((year, index) => (
              <div
                className={styles.item}
                key={index}
                onClick={() => handleYearClick(year)}
              >
                <Text
                  title={String(year)}
                  variant="text-bold-italic-16-black"
                  style={{ cursor: 'pointer' }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
      <Text
        title=""
        variant="text-bold-italic-20"
        className={styles.text}
        onClick={nextMonth}
        svg={right}
      />
    </div>
  );
};

export default CalendarHeader;
